<template>
    <div class="collection-filter">
        <DCol>
            <DRow
                class="mb-3"
                align-vertical="end"
            >
                <DCol
                    sm="4"
                    class="pt-1"
                >
                    <DInput
                        id="collection_search"
                        :label="__('tools.collection.filters.search')"
                        class="mb-0"
                        :value="search"
                        @input="$emit('update:search', $event.target.value)"
                        @keydown.enter.exact.prevent="$emit('filter')"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DInput
                        id="date_from"
                        type="date"
                        :label="__('tools.collection.filters.date_from')"
                        class="mb-0"
                        :value="dateFrom"
                        @input="$emit('update:date-from', $event.target.value)"
                        @keydown.enter.exact.prevent="$emit('filter')"
                    />
                </DCol>
                <DCol
                    sm="2"
                    class="pt-1"
                >
                    <DInput
                        id="date_to"
                        type="date"
                        :label="__('tools.collection.filters.date_to')"
                        class="mb-0"
                        :value="dateTo"
                        @input="$emit('update:date-to', $event.target.value)"
                        @keydown.enter.exact.prevent="$emit('filter')"
                    />
                </DCol>
                <DCol
                    sm="3"
                    class="d-flex gap-2"
                >
                    <DButton
                        :label="__('tools.collection.filters.filter')"
                        @click="$emit('filter')"
                    />
                    <DButton
                        icon="filter-off"
                        :label="__('messages.actions.reset_filter')"
                        @click="resetFilters"
                    />
                </DCol>
            </DRow>
        </DCol>
    </div>
</template>

<script>
export default {
    name: 'CollectionFilter',
    props: {
        search: {
            type: String,
            default: null
        },
        dateFrom: {
            type: String,
            default: null
        },
        dateTo: {
            type: String,
            default: null
        }
    },
    emits: ['update:search', 'update:date-from', 'update:date-to', 'filter'],
    methods: {
        resetFilters () {
            this.$emit('update:search', null)
            this.$emit('update:date-to', null)
            this.$emit('update:date-from', null)
            this.$emit('filter')
        }
    }
}
</script>
